function isExternalPath(path) {
  return /^https?:\/\/.+/.test(path);
}

export default isExternalPath;
